<script setup>
import { ref, onMounted } from "vue";
import WidgetLayout from "@/Layouts/WidgetLayout.vue";

const props = defineProps({
    office: Object,
    widgetkey: String,
    widgeteid: String,
});
const backUrl = ref("/");

let pymChild = null;

onMounted(() => {
    if(typeof pym !== "undefined") {
        pymChild = new pym.Child({ id: props.widgeteid });
    }
});
function backClicked() {
    backUrl.value = window.history.back();
}
</script>

<template>
    <WidgetLayout :office="props.office">
        <h2 class="lg:w-2/3 text-3xl font-semibold mb-8">
            Es wurde leider keine freien Termine gefunden.<br>
            Bitte passen Sie Ihre Auswahl an.
        </h2>

        <div class="mt-12 py-6 flex justify-between">
            <a
                class="px-6 md:px-20 py-3 text-xl font-semibold rounded-lg text-white bg-primary hover:opacity-70 cursor-pointer"
                @click="backClicked"
                :href="backUrl"
                >Zurück zur Auswahl</a
            >
        </div>
    </WidgetLayout>
</template>

<style>
.bg-primary {
    background-color: #006eb4;
}
</style>
